import React from 'react';
import styles from 'Custom/BannerCTA/index.module.scss';
import Container from 'Nori/Container';
import RichText from 'Custom/RichText';
import Button from 'Nori/Button';
import { useAppContext } from 'Providers/App';
import { UI_ELEMENTS } from 'Providers/App/elements';

const { modalExternalLink: modalExternalLinkId } = UI_ELEMENTS;

const BLOCK_BACKGROUND = {
  secondary2Light: styles.secondary2Light,
  secondary4Light: styles.secondary4Light,
  default: styles.secondary2Light,
  marble: styles.marble,
};

const BUTTON_VARIANT = {
  secondary2Light: 'secondary2',
  secondary4Light: 'secondary4',
  default: 'secondary2',
  marble: 'primaryLight',
};

const BannerCTA = ({
  className = '',
  color = 'secondary2Light',
  button = {
    showModal: false,
    href: '/',
    label: 'NEXPLANON',
    target: '_self',
  },
  moduleName,
  moduleNo,
  children,
  ...props
}) => {
  const { setExternalUrl, getElementClickHandler } = useAppContext();
  const backgroundClassName =
    BLOCK_BACKGROUND[color] || BLOCK_BACKGROUND.default;
  const buttonVariant = BUTTON_VARIANT[color] || BUTTON_VARIANT.default;

  const modalExternalLinkHandler = getElementClickHandler(modalExternalLinkId);

  return (
    <div
      className={`${styles.wrapper} ${backgroundClassName} ${className}`}
      {...props}
      data-design-visible="visible_vd"
      data-design-type="module"
      data-design-nori_id="CTA"
      data-design-module_name={moduleName}
      data-design-module_no={moduleNo}
      data-qa-tag="banner-cta-wrapper"
    >
      <Container data-qa-tag="banner-cta-container">
        <RichText
          className={styles.mainContainer}
          data-qa-tag="banner-cta-main-container"
        >
          <div className={styles.copy} data-qa-tag="banner-cta-copy">
            {children}
          </div>

          {button.showModal ? (
            <Button
              className={styles.btn}
              onClick={(event) => {
                modalExternalLinkHandler(event);
                setExternalUrl(
                  'https://www.fda.gov/safety/medwatch-fda-safety-information-and-adverse-event-reporting-program'
                );
              }}
              type={buttonVariant}
              data-design-type="clickAction"
              data-design-category="button_vd"
              data-design-action="Expand"
              data-design-label={button.label}
              data-design-nori_id="CTA"
              data-design-module_name={moduleName}
              data-design-module_no={moduleNo}
              data-qa-tag="banner-cta-button"
            >
              {button.label}
            </Button>
          ) : (
            <Button
              className={styles.btn}
              href={button.href}
              target={button.target}
              type={buttonVariant}
              data-design-type="clickAction"
              data-design-category="button_vd"
              data-design-action="Button"
              data-design-label={button.label}
              data-design-nori_id="CTA"
              data-design-module_name={moduleName}
              data-design-module_no={moduleNo}
              data-qa-tag="banner-cta-button"
            >
              {button.label}
            </Button>
          )}
        </RichText>
      </Container>
    </div>
  );
};

export default BannerCTA;
